module.exports = __webpack_public_path__ + "img/godfroy.bb97d96b.jpg";